import { b64decode } from "../b64";
import { HttpServiceBase } from "./http-service-base";

export class RequisitionServiceMock {
  generateString(length) {
    const characters = "abcdefgh01234567890";
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  async sign(requisitionId) {
    const f = this.generateString;
    const codes = () => {
      let x = [];
      for (let t = 0; t < 180; t++) {
        let item =
          "bankid." +
          f(8) +
          "-" +
          f(4) +
          "-" +
          f(4) +
          "-" +
          f(8) +
          "." +
          t +
          "" +
          f(64);
        x.push(item);
      }
      return x;
    };

    return new Promise((resolve) =>
      resolve({
        frames: codes(),
      })
    );
  }

  async verifySign(requisitionId) {
    return Promise((resolve) => resolve({ status: "pending" }));
  }
}

export class RequisitionService extends HttpServiceBase {
  version = "v2";

  constructor(...rest) {
    super(...rest);
  }

  async delete(requisitionId) {
    return await this.http.delete(
      `${this.version}/requisitions/${requisitionId}`
    );
  }

  async list() {
    let ok = await this.http.get(
      `${this.version}/requisitions/?role=application`
    );
    return JSON.parse(ok.response);
  }

  create(b64applicationId) {
    return new Promise((resolve, reject) => {
      let applicationId = b64decode(b64applicationId);
      console.log("create applicationId", applicationId);

      this.http
        .post(`${this.version}/requisitions/`, {
          applicationId: applicationId,
        })
        .then((message) => JSON.parse(message.response))
        .then((report) => resolve(report))
        .catch((e) => reject(e));
    });
  }

  getByApplicationId(applicationId) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.version}/requisitions/?role=application&applicationId=${applicationId}`
        )
        .then((message) => JSON.parse(message.response))
        .then((report) => resolve(report))
        .catch((e) => reject(e));
    });
  }

  async get(requisitionId) {
    let resp = await this.http.get(
      `${this.version}/requisitions/${requisitionId}`
    );
    return JSON.parse(resp.response);
  }

  async getCurrency(requisitionId) {
    let resp = await this.http.get(
      `${this.version}/requisitions/${requisitionId}/currency`
    );
    return JSON.parse(resp.response);
  }

  async submit(requisitionId, printUrl) {
    console.log("requisitionId", requisitionId);
    console.log("printUrl", printUrl);
    return await this.http.post(`${this.version}/requisitions/submit`, {
      requisitionId: requisitionId,
      printUrl: printUrl,
    });
  }

  async sign(requisitionId, printUrl) {
    let x = await this.http.post(
      `${this.version}/requisitions/${requisitionId}/bankid/submit`,
      {
        requisitionId: requisitionId,
        printUrl: printUrl,
      }
    );
    return JSON.parse(x.response);
  }

  async verifySign(requisitionId) {
    let x = await this.http.get(
      `${this.version}/requisitions/${requisitionId}/bankid/status`
    );
    return JSON.parse(x.response);
  }
}
